import CmsComponent from "@/helpers/editor/components/CmsComponent.js";
import CompatibilityHelper from "@/helpers/CompatibilityHelper.js";

export default class CmsComponentBackground extends CmsComponent{
    static BACKGROUNDS = {
        // NONE: `none`, replaced with active = false
        IMAGE: `image`,
        COLOR: `color`
        // GRADIENT: `gradient`
    }

    get autoGenerateId() {
        return false;
    }

    constructor(data) {
        super(data);

        if (!data) {
            this.type = CmsComponentBackground.BACKGROUNDS.COLOR;
            this.color = `#777777`;
            this.image = null;
            this.radius = `var(--border-radius)`;
        } else {
            this.color = CompatibilityHelper.checkColor(this.color);
        }
    }

    init(type = CmsComponentBackground.BACKGROUNDS.COLOR, color = `#777777`, image = null, radius = `var(--border-radius)`) {
        this.type = type;
        this.color = color;
        this.image = image;
        this.radius = radius;
    }

    loadStyle(data) {
        this.type = data.type || CmsComponentBackground.BACKGROUNDS.COLOR;
        this.color = data.color || `#777777`;
        this.image = data.image || null;
        this.radius = data.radius || `var(--border-radius)`;
    }
}
